<div class="progress-overlay" [ngStyle]="{backgroundColor: overlayColor}" *ngIf="displayToggle==true">
    <div class="progress-overlay-content">
        <svg width="100%" height="100%" viewBox="0 0 42 42" class="donut">
            <circle class="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#eeeeee" [attr.stroke-width]="donutWidth"></circle>
            <circle class="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" [attr.stroke]="progressColor" [attr.stroke-width]="donutWidth" [attr.stroke-dasharray]="progressFormatted" stroke-dashoffset="25"></circle>
            <g class="progress-content-text">
                <text x="50%" y="50%" class="progress-content-number" [ngStyle]="{fill: valueColor}">
                {{progressValue}}%
                </text>
                <text x="50%" y="50%" class="progress-content-label" [ngStyle]="{fill: textColor}">
                {{progressText}}
                </text>
            </g>
        </svg>
    </div>
</div>